import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    grupos: [],
    grupo: []


  },
  mutations: {

    LoadProductos(state, buscar) {
      //let aux = [];
      state.grupo = state.grupos;

      let aux = state.grupos.filter((x) => x["nombregrupo"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.grupo = state.grupos;
      } else {
        state.grupo = aux;

      }
    },
    async cargardatosgrupos(state) {

      state.grupos = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.grupos = response.data.data;

        });
      state.grupo = state.grupos
    },

    cambio(state, descripcion) {

      state.descripcionmodal = descripcion

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombregrupo: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal



      var datosfalso = state.idmodal;

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;
          })

          .catch((e) => {
            console.log(e);
          });
      } else {

        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;

          })

          .catch((e) => {
            console.log(e);
          });
      }

    },


    datosmodal(state, api) {

      state.idmodal = api.idgrupo,
        state.descripcionmodal = api.nombregrupo

    },



    eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;

          //this.bandera = true;
        })

        .catch((e) => {
          console.log(e);
        });



    },



  },
  actions: {

  },
  getters: {


  },






}